import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import Select from '../common/form/select';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';

import { setModoTela, initForm } from './imobiliariaActions';

class ImobiliariaForm extends Component {

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='nome'
								component={LabelAndInput}
								label='Razão Social *' placeholder='Informe o Nome'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='cnpj'
								component={LabelAndInputMask}
								label='CNPJ *' placeholder='Informe o CNPJ'
								cols='12 6 4 3'
								mask='99.999.999/9999-99'
								readOnly={readOnly} />

							<Field
								name='endereco'
								component={LabelAndInput}
								label='Endereço *' placeholder='Informe o endereço'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='creci'
								component={LabelAndInput}
								label='CRECI *' placeholder='Informe'
								cols='12 4 4 3'
								readOnly={readOnly} />

							<Field
								name='email'
								component={LabelAndInput}
								label='E-mail *' placeholder='Informe'
								cols='12 4 4 3'
								readOnly={readOnly} />

							<Field
								name='celular'
								component={LabelAndInputMask}
								label='Celular *' placeholder='Informe'
								cols='12 4 4 3'
								readOnly={readOnly}
								mask='(99) 9 9999-9999' />.

						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

ImobiliariaForm = reduxForm({form: 'imobiliariaForm', destroyOnUnmount: false})(ImobiliariaForm);
const mapStateToProps = state => ({
	sessao: state.auth.imobiliaria,
	formularioValues: getFormValues('imobiliariaForm')(state),
	registro: state.imobiliaria.registro,
	listaRegiao: state.imobiliaria.listaRegiao,
	listaLocalEstoque: state.imobiliaria.listaLocalEstoque
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ImobiliariaForm);
